import { render, staticRenderFns } from "./TreeCategoryWidget.vue?vue&type=template&id=4923ceb4&"
import script from "./TreeCategoryWidget.vue?vue&type=script&lang=js&"
export * from "./TreeCategoryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports